import { render, staticRenderFns } from "./cn_pubtips.vue?vue&type=template&id=3524691e&scoped=true&"
import script from "./cn_pubtips.vue?vue&type=script&lang=js&"
export * from "./cn_pubtips.vue?vue&type=script&lang=js&"
import style0 from "./cn_pubtips.vue?vue&type=style&index=0&id=3524691e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3524691e",
  null
  
)

export default component.exports